import { useCallback, useContext } from 'react';

import type { ReturnToWalletSettingsTab } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

const useReturnToWalletSettingsTab = () => {
  const { sendRequest } = useContext(MessagingContext)!;

  return useCallback(
    async () =>
      sendRequest<ReturnToWalletSettingsTab>('returnToWalletSettingsTab', {}),
    [sendRequest]
  );
};

export default useReturnToWalletSettingsTab;
